<template>
  <div class="map-tips-container">
    <div class="item">
      <i class="icon">
        <img src="@/assets/images/car-1.png" alt="">
      </i>
      正常车辆
    </div>
    <div class="item">
      <i class="icon">
        <img src="@/assets/images/car-2.png" alt="">
      </i>
      离线车辆
    </div>
    <div class="item">
      <i class="icon">
        <img src="@/assets/images/car-3.png" alt="">
      </i>
      报警车辆
    </div>
    <div class="item">
      <i class="icon">
        <img src="@/assets/images/car-warn.png" alt="">
      </i>
      事故
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
.map-tips-container {
  position: absolute;
  bottom: 8px;
  right: 396px;
  background: rgba(24,44,76,0.7);
  padding: 10px 12px;
  border: 2px solid #012535;
  z-index: 10;
  .item {
    color: #fff;
    & + .item {
      margin-top: 14px;
    }
    .icon {
      display: inline-block;
      width: 24px;
      text-align: center;
      margin-right: 10px;
    }
  }
}
</style>
